import { Component, Inject, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CalibrationlogoEnum } from 'app/enum/calibrationlogoEnum';
import { CalibrationService } from 'app/services/models/calibration.service';
import { CertificateReservationService } from 'app/services/models/certificate-reservation.service';
import { CertificateService } from 'app/services/models/certificate.service';
import { Turkish } from 'flatpickr/dist/l10n/tr';
import moment from 'moment';
import { FlatpickrOptions } from 'ng2-flatpickr';
import QRCode from 'qrcode';
import * as pdfjsLib from 'pdfjs-dist';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { CoreConfigService } from '@core/services/config.service';
import { Subject, takeUntil } from 'rxjs';
import { CompanyService } from 'app/services/models/company.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-create-certificate-dialog',
  templateUrl: './create-certificate-dialog.component.html',
  styleUrls: ['./create-certificate-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CreateCertificateDialogComponent implements OnInit {
  @Input() data: { calibrationId: number; };
  calibration: any = {};
  certificateForm: FormGroup; // Form için tanımlama
  public coreConfig: any;
  private _unsubscribeAll: Subject<any>;

  constructor(
    public activeModal: NgbActiveModal,
    private certificateService: CertificateService,
    private calibrationService: CalibrationService,
    private certificateReservationService: CertificateReservationService,
    private _coreConfigService: CoreConfigService,
    private toastrService: ToastrService,
    private fb: FormBuilder,
    @Inject('backendUrl') private backendUrl: string,
    private companyService: CompanyService
  ) {
    pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.10.377/pdf.worker.min.js';
    this._unsubscribeAll = new Subject();
  }

  certificateNumber: string = null;
  certificateReservations?: any[] = [];
  pageCount: number = 2;

  date = new Date();
  date2 = moment().add(1, 'year').toDate();

  public dateTimeStartOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  public dateTimeEndOptions: FlatpickrOptions = {
    altInput: true,
    enableTime: true,
    dateFormat: 'd.m.Y',
    altFormat: 'd.m.Y',
    locale: Turkish,
  };

  async ngOnInit() {
    this.certificateForm = this.fb.group({
      certificateNo: [this.certificateNumber, Validators.required],
      issueDate: ['', Validators.required],
      expiryDate: ['', Validators.required],
      visualAndFunctional: [true],
    });
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
    await this.getLastCerticateNumber();
    await this.getByIdCalibration(this.data.calibrationId);

  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  async getAllCertificateReservations(companyId) {
    const data = await this.certificateReservationService.getByIdCompanyCertificateReservations(companyId);
    this.certificateReservations = data;
  }

  closeModal() {
    this.activeModal.close(false);
  }

  async getLastCerticateNumber() {
    const data = await this.certificateService.getLastCertificate();
    this.certificateNumber = data;
    setTimeout(() => {
      this.certificateForm.patchValue({
        certificateNo: this.certificateNumber
      });
    });
  }

  async getByIdCalibration(id) {
    const data = await this.calibrationService.getByIdReadyCalibration(id);
    console.log(data);
    this.calibration = data;
    this.getAllCertificateReservations(data.deliveryDevice?.company?.id)
  }

  onReservationSelect(reservation: any) {
    console.log(reservation);
    if (reservation) {
      this.certificateNumber = reservation.reservedCertificateNo;
      this.certificateForm.patchValue({
        certificateNo: this.certificateNumber
      });
    }
  }

  async resetCertificateNumber() {
    await this.getLastCerticateNumber(); // Eski değeri al
  }

  onSubmit() {
    console.log(this.certificateForm.value)
  }

  qrCodeBase64: string;

  async generateQRCode(certificateNo: string): Promise<void> {
    // URL'yi oluşturuyoruz
    const url = `${this.backendUrl}Certificate/${certificateNo}.pdf`;

    try {
      // QR kodunu Base64 formatında oluşturuyoruz
      this.qrCodeBase64 = await QRCode.toDataURL(url);  // Base64 formatında QR kodu al
      console.log(this.qrCodeBase64); // Konsola QR kodunun Base64 çıktısını yazdır
    } catch (err) {
      console.error('QR Kod oluşturulurken hata oluştu:', err);
    }
  }
  img: string[] = [];

  currentPage = 1;  // İlk sayfa
  totalPages = 0;
  pdfDoc: any = null; // PDF dosyasını tutacak
  onFileSelected2(event: Event): void {
    const fileInput = event.target as HTMLInputElement;
    const file = fileInput.files ? fileInput.files[0] : null;

    if (file) {
      const reader = new FileReader();

      // Dosya okuma işlemi tamamlandığında bu fonksiyon çalışacak
      reader.onload = (e: ProgressEvent<FileReader>) => {
        const typedArray = new Uint8Array(e.target?.result as ArrayBuffer);

        // PDF dosyasını pdf.js ile açıyoruz
        pdfjsLib.getDocument(typedArray).promise.then(pdf => {
          this.pdfDoc = pdf;  // PDF dokümanını tutuyoruz
          this.totalPages = pdf.numPages;  // Toplam sayfa sayısını alıyoruz
          const canvasArray: string[] = [];  // Her sayfa için Base64 görseli tutacak dizi

          // Sayfa render işlemi
          const renderPage = (pageNum: number) => {
            pdf.getPage(pageNum).then(page => {
              const scale = 1.5;  // Sayfa ölçeği
              const viewport = page.getViewport({ scale: scale });

              // Canvas oluşturuyoruz
              const canvas = document.createElement('canvas');
              const context = canvas.getContext('2d')!;
              canvas.height = viewport.height;
              canvas.width = viewport.width;

              // Sayfayı canvas'a render ediyoruz
              page.render({
                canvasContext: context,
                viewport: viewport
              }).promise.then(() => {
                const imgData = canvas.toDataURL('image/png');  // Canvas'ı Base64 formatında alıyoruz
                canvasArray.push(imgData);  // Görseli array'e ekliyoruz

                // Eğer tüm sayfalar render edildiyse, yeni sekmede her sayfa görselini açıyoruz
                if (canvasArray.length === this.totalPages) {
                  this.img = canvasArray;  // Tüm Base64 görsellerini saklıyoruz
                  this.openAllPagesInNewTabs(canvasArray);  // Tüm sayfaları yeni sekmelerde açıyoruz
                }
              });
            });
          };

          // Sayfaları sırayla işliyoruz
          for (let pageNum = 1; pageNum <= this.totalPages; pageNum++) {
            renderPage(pageNum);
          }
        });
      };

      reader.readAsArrayBuffer(file);  // Dosyayı okuyoruz
    }
  }

  openAllPagesInNewTabs(imgDataArray: string[]) {
    const container = document.getElementById('pdf-container');  // Sayfada görselleri ekleyeceğimiz container

    imgDataArray.forEach(imgData => {
      const imgElement = document.createElement('img');
      imgElement.src = imgData;  // Base64 görseli img etiketi kaynağı olarak ayarlıyoruz
      imgElement.style.width = '100%';  // Görselin genişliğini sayfaya uyacak şekilde ayarlıyoruz
      imgElement.style.marginBottom = '20px';  // Sayfalar arasında boşluk bırakıyoruz
      container?.appendChild(imgElement);  // Görseli container'a ekliyoruz
    });
  }

  async convertImageToBase64(url: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = 'anonymous'; // CORS hatalarını önlemek için
      img.src = url;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        if (!ctx) return reject(null);
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL('image/png'));
      };

      img.onerror = (err) => {
        console.error("Resim yüklenemedi!", url, err);
        reject(null);
      };
    });
  }


  logo = null;
  getByIdLogo(number: number): string | null {
    const logos = Object.values(CalibrationlogoEnum);
    this.logo = logos[number - 1] || null;
    return this.logo;
  }

  async generatePDF(headerData: headerBilgileri, calibrationData: CalibrationData, calibrationPage2: CalibrationPage2, isSave: boolean = false) {
    // Convert image paths to Base64 asynchronously
    calibrationData.certificatePageNumber = this.pageCount + this.totalPages;
    // headerData.firmaLogo = await this.convertImageToBase64(headerData.firmaLogo) || '';
    const akraditasyonLogoPath = this.getByIdLogo(headerData.akraditationFirma);
    const akraditasyonFirma = await this.convertImageToBase64(akraditasyonLogoPath) || '';
    // Document definition
    const documentDefinition = {
      pageSize: 'A4',
      pageMargins: [40, 170, 40, 90],

      // Header for each page
      header: (currentPage, pageCount, pageSize) => {
        return this.getHeaderContent(currentPage, akraditasyonFirma, headerData);
      },
      // Content of the document (multiple pages)
      content: [
        await this.createCalibrationPageContent(calibrationData, true),
        this.createCalibrationPage2(calibrationPage2),
        this.createCalibrationOtherPage(this.img)
      ],
      // Footer for each page
      footer: (currentPage, pageCount) => this.getFooterContent(currentPage, pageCount, calibrationData.firstPageDescription)
    }
    const pdfDocGenerator = pdfMake.createPdf(documentDefinition as unknown as TDocumentDefinitions);

    console.log(this.certificateForm.value);

    if (isSave) {
      pdfDocGenerator.getBase64(async (base64Data) => {
        const data = await this.certificateService.createCertificate({
          base64Data: base64Data,
          calibrationId: this.data.calibrationId,
          certificateNo: headerData.certificateNo.toString(),
          expiryDate: new Date(this.certificateForm.value.expiryDate[0]),
          issueDate: new Date(this.certificateForm.value.issueDate[0]),
        });
        if (data.status) {
          this.closeModal();
          this.toastrService.success(data.message);
        } else {
          this.toastrService.error(data.message);
        }
      })
    } else {
      pdfDocGenerator.open();
    }
    // Generate and open the PDF
  }

  async createCalibrationPageContent(calibrationData: CalibrationData, pageBreak: boolean) {
    let firstPageDescriptionToHtml = htmlToPdfmake(calibrationData.firstPageDescription);
    firstPageDescriptionToHtml = this.applyDefaultFontSize(firstPageDescriptionToHtml);

    const seal = await this.convertImageToBase64('/assets/logo/muhur.png').catch(err => console.log(err));
    const imza1 = await this.convertImageToBase64('/assets/logo/e-imza.png').catch(err => console.log(err));
    await this.generateQRCode(calibrationData.certificateNo);
    return [
      {
        table: {
          widths: ['30%', '70%'], // İlk sütun başlık, ikinci sütun veri
          body: [
            [{ text: 'Cihaz Sahibi:', bold: true, fontSize: 10 }, { text: `${calibrationData.deviceOwner}`, fontSize: 10 }],
            [{ text: 'Customer', fontSize: 8, margin: [0, 0, 0, 5] }, { text: `${calibrationData.address}`, fontSize: 8 }],

            [{ text: 'Sipariş Numarası:', bold: true, fontSize: 10 }, { text: `${calibrationData.orderNumber}`, fontSize: 10 }],
            [{ text: 'Order No', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Cihaz:', bold: true, fontSize: 10 }, { text: `${calibrationData.deviceName}`, fontSize: 10 }],
            [{ text: 'Device', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Marka:', bold: true, fontSize: 10 }, { text: `${calibrationData.manufacturer}`, fontSize: 10 }],
            [{ text: 'Brand', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Model:', bold: true, fontSize: 10 }, { text: `${calibrationData.modelType}`, fontSize: 10 }],
            [{ text: 'Type', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Seri Numarası:', bold: true, fontSize: 10 }, { text: `${calibrationData.serialNumber}`, fontSize: 10 }],
            [{ text: 'Serial Number', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Kalibrasyon Tarihi:', bold: true, fontSize: 10 }, { text: `${calibrationData.calibrationDate}`, fontSize: 10 }],
            [{ text: 'Date of Calibration', fontSize: 8, margin: [0, 0, 0, 5] }, {}],

            [{ text: 'Sertifika Sayfa Numarası:', bold: true, fontSize: 10 }, { text: `${calibrationData.certificatePageNumber}`, fontSize: 10 }],
            [{ text: 'Number of Pages of The Certificate', fontSize: 8, margin: [0, 0, 0, 5] }, {}],
          ]
        },
        layout: 'noBorders', // Tablo çizgilerini kaldırdım
        margin: [0, 0, 0, 2],
      },
      {
        stack: [firstPageDescriptionToHtml]
      },
      {
        table: {
          widths: ['25%', '25%', '25%', '25%'],
          body: [
            [{ text: "Mühür", bold: true, fontSize: 8, alignment: 'center' }, { text: "Kontrol Kodu", bold: true, fontSize: 8, alignment: 'center' }, { text: "Kalibrasyon Yapan", bold: true, fontSize: 8, alignment: 'center' }, { text: "Onaylayan", bold: true, fontSize: 8, alignment: 'center' }],
            [{ text: "Seal", fontSize: 6, alignment: 'center' }, { text: "Qr Code", fontSize: 6, alignment: 'center' }, { text: "Calibrated by", fontSize: 6, alignment: 'center' }, { text: "Approval", fontSize: 6, alignment: 'center' }],
            [{ image: seal, fit: [75, 75], alignment: 'center' }, { image: this.qrCodeBase64, fit: [75, 75], alignment: 'center' }, [
              { text: calibrationData.kalYapan, fontSize: 10, alignment: 'center', marginBottom: 5 },
              { image: imza1, fit: [75, 75], alignment: 'center' }
            ], [
              { text: calibrationData.onaylayan, fontSize: 10, alignment: 'center', marginBottom: 5 },
              { image: imza1, fit: [75, 75], alignment: 'center' }
            ]]
          ],
        },
        layout: 'noBorders',
        margin: [0, 5, 0, 0],
      },
      pageBreak ? { text: '', pageBreak: 'after' } : { text: '' },
    ];
  }

  applyDefaultFontSize(obj: any) {
    if (Array.isArray(obj)) {
      return obj.map(item => this.applyDefaultFontSize(item));
    } else if (typeof obj === "object" && obj !== null) {
      if (!obj.fontSize) {
        obj.fontSize = 10; // Varsayılan font size ekle
      }
      // Eğer fontSize 10 ve 'ql-size-small' varsa, 8 yapalım
      if (obj.fontSize === 10 && obj.text && obj.style?.includes("ql-size-small")) {
        obj.fontSize = 8; // `ql-size-small` varsa font size'ı 8 yapıyoruz
      }
      // Margin'i küçültme (margin varsa %20 oranında küçültme)
      if (obj.margin) {
        obj.margin = obj.margin.map((m: number) => m * 0.1); // Margin'i %20 oranında küçültme
      }
      // Nesnenin içindeki diğer öğeleri kontrol et
      Object.keys(obj).forEach(key => {
        obj[key] = this.applyDefaultFontSize(obj[key]);
      });
    }
    return obj;
  }

  createCalibrationPage2(calibrationPage2: CalibrationPage2) {
    let calibrationText = htmlToPdfmake(calibrationPage2.description);
    calibrationText = this.applyDefaultFontSize(calibrationText);

    let remaksToHtml = htmlToPdfmake(calibrationPage2.remarks);
    remaksToHtml = this.applyDefaultFontSize(remaksToHtml);

    let complianceToHtml = htmlToPdfmake(calibrationPage2.compliance);
    complianceToHtml = this.applyDefaultFontSize(complianceToHtml);

    let measurementToHtml = htmlToPdfmake(calibrationPage2.measurement);
    measurementToHtml = this.applyDefaultFontSize(measurementToHtml);
    return [
      {
        text: [
          {
            text: "Kalibre Edilen Cihaz /", bold: true, fontSize: 12,
          },
          {
            text: "Device to be calibrate", fontSize: 10,
          },
        ],
        margin: [0, -50, 0, 0]
      },
      {
        columns: [
          {
            table: {
              widths: ['50%', '50%'], // İki sütunlu tablo
              body: [
                // İlk tablo: Cihaz bilgileri
                [{ text: 'Cihaz Adı / Device Name :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.deviceName}`, fontSize: 10 }],
                [{ text: 'Seri Numarası / Serial No :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.serialNo}`, fontSize: 10 }],
                [{ text: 'Cihaz No / Device No :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.deviceNumber}`, fontSize: 10 }],
                [{ text: 'Bulunduğu Yer / Location :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.location}`, fontSize: 10 }],
              ]
            },
            layout: 'noBorders', // Tablo çizgilerini kaldırdım
            margin: [0, 5, 0, 0],
          },
          {
            table: {
              widths: ['50%', '50%'], // İkinci tablo: Model ve ölçüm bilgileri
              body: [
                [{ text: 'Marka Tipi / Brand Type :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.brand}`, fontSize: 10 }],
                [{ text: 'Model / Model :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.type}`, fontSize: 10 }],
                [{ text: 'Ölçüm Aralığı / Range :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.range}`, fontSize: 10 }],
                [{ text: 'Çözünürlük / Resolution :', bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.resolution}`, fontSize: 10 }],
              ]
            },
            layout: 'noBorders', // Tablo çizgilerini kaldırdım
            margin: [0, 5, 0, 0],
          },
          // Tabloların altındaki ek bilgiler
        ],
      },
      {
        table: {
          widths: ['50%', '50%'],
          body: [
            [{ text: `Cihazın Laboratuvara Kabul Tarihi:`, bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.incomingDateOfDeviceLaboratory}`, fontSize: 10 }],
            [{ text: `Cihazın Görsel ve Fonksiyonel Kontrolü:`, bold: true, fontSize: 10 }, { text: `${calibrationPage2.device.visualFunctionInspectionDevice}`, fontSize: 10 }]
          ],
        },
        layout: 'noBorders',
        margin: [0, 0, 0, 0],
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Kalibrasyonda Kullanılan Cihazlar /", bold: true, fontSize: 12 },
                  { text: "References used in calibration", fontSize: 10 },
                ]
              }
            ],
            margin: [0, 10, 0, 0],
          },
          {
            table: {
              widths: ['14.2%', '14.2%', '14.2%', '14.2%', '14.2%', '14.2%', '14.2%'], // 7 sütun için genişlikleri belirledim
              body: [
                [{ text: 'Cihaz Adı', fontSize: 10, bold: true }, { text: 'Marka', fontSize: 10, bold: true }, { text: 'Model', fontSize: 10, bold: true }, { text: 'Seri No', fontSize: 10, bold: true }, { text: 'Sertfika No', fontSize: 10, bold: true }, { text: 'Kal. Tarihi', fontSize: 10, bold: true }, { text: 'İzlenebilirlik', fontSize: 10, bold: true }],
                [{ text: 'Device Name', fontSize: 8, bold: true }, { text: 'Brand', fontSize: 8, bold: true }, { text: 'Model', fontSize: 8, bold: true }, { text: 'Serial No', fontSize: 8, bold: true }, { text: 'Certificate No', fontSize: 8, bold: true }, { text: 'Cal. Date', fontSize: 8, bold: true }, { text: 'Tracebility', fontSize: 8, bold: true }],
                ...calibrationPage2.references.map(ref => [
                  { text: ref.deviceName, fontSize: 9 },
                  { text: ref.brand, fontSize: 9 },
                  { text: ref.model, fontSize: 9 },
                  { text: ref.serialNumber, fontSize: 9 },
                  { text: ref.certificateNumber, fontSize: 9 },
                  { text: ref.calibrationDate, fontSize: 9 },
                  { text: ref.tracebility, fontSize: 9 } // İzlenebilirlik için örnek veri (isteğe bağlı)
                ])
              ],
            },
            layout: 'noBorders',
            margin: [0, 5, 0, 0],
          }

        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Ortam Şartları /", bold: true, fontSize: 12 },
                  { text: "Environment Conditions", fontSize: 10 },
                ]
              }
            ],
            margin: [0, 10, 0, 0],
          },
          {
            table: {
              widths: ["*", "*", "*"],
              body: [
                [{ text: "Şart / Condition", bold: true, fontSize: 9 }, { text: "Başlangıç / Start", bold: true, fontSize: 9 }, { text: "Bitiş / End", bold: true, fontSize: 9 }],
                ...(calibrationPage2.evironmentalConditions || []).map(ref => [
                  { text: ref.name || "-", fontSize: 8 },
                  { text: ref.start || "-", fontSize: 8 },
                  { text: ref.end || "-", fontSize: 8 },
                ])
              ],
            },
            layout: 'noBorders',
            margin: [0, 5, 0, 0],
          }
        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Kalibrasyon Metodu /", bold: true, fontSize: 12 },
                  { text: "Calibration Method", fontSize: 10 },
                ]
              },
            ],
            margin: [0, 10, 0, 0],
          },
          {
            stack: [calibrationText],
          }
        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Açıklama /", bold: true, fontSize: 12 },
                  { text: "Remarks", fontSize: 10 },
                ]
              },
            ],
            margin: [0, 10, 0, 0],
          },
          {
            stack: [remaksToHtml]
          }
        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Uygunluk Beyanı /", bold: true, fontSize: 12 },
                  { text: "Statement Of Complance", fontSize: 10 },
                ]
              },
            ],
            margin: [0, 10, 0, 0],
          },
          {
            stack: [complianceToHtml]
          }
        ]
      },
      {
        stack: [
          {
            columns: [
              {
                text: [
                  { text: "Ölçüm Belirsizliği /", bold: true, fontSize: 12 },
                  { text: "Measurement Uncertaintily", fontSize: 10 },
                ]
              },
            ],
            margin: [0, 10, 0, 0],
          },
          {
            stack: [measurementToHtml]
          }
        ]
      },
      // Sayfa sonu eklemeleri (isteğe bağlı)
      { text: '', pageBreak: 'after' }, // Eğer sayfa sonu gerekiyorsa, sayfa kesme ekleyebilirsiniz
    ];
  }

  createCalibrationOtherPage(imgData: string[]) {

    const pageContent = [];

    // Sayfa başına bir görsel ekliyoruz ve her sayfada bir kırılma ekliyoruz.
    for (let i = 0; i < imgData.length; i++) {
      pageContent.push({
        image: imgData[i],
        alignment: 'center',
        fit: [850, 850],
        margin: [0, 40, 0, 0], // Görsel ile header arasına boşluk bırakabiliriz
        absolutePosition: { x: 40, y: 100 }, // Y konumunu her sayfa için ayarlayabilirsiniz
        pageBreak: i < imgData.length - 1 ? 'after' : undefined // Son görselden sonra sayfa kırılması ekliyoruz
      });
    }

    return pageContent;
  }

  // Header content function
  getHeaderContent(currentPage, akraditasyonFirma, headerData: headerBilgileri,) {
    return {
      stack: [
        {
          columns: [
            this.getLeftColumn(headerData),
            this.getCenterColumn(headerData), // Pass headerData here
            this.getRightColumn(akraditasyonFirma, headerData.akraditationNo, headerData.certificateNo, headerData.certificateTarih, currentPage),
          ],
          margin: [40, 20, 20, 10],
        },
        { canvas: [{ type: 'line', x1: 30, y1: 0, x2: 545, y2: 0, lineWidth: 1 }] },
      ],
    };
  }

  // Left column content
  getLeftColumn(headerData) {
    return {
      width: '25%',
      stack: headerData.firmaLogo ? [
        { image: headerData.firmaLogo, fit: [75, 75] }
      ] : [
        { text: "", fontSize: 10, italics: true }
      ],
      alignment: 'left',
    };
  }

  // Center column content
  getCenterColumn(headerData) {
    return {
      width: '50%',
      stack: [
        { text: `${headerData.firmaAdi}`, bold: true, fontSize: 14 },
        { text: `${headerData.firmaAdresi}`, fontSize: 10 },

        { text: "KALİBRASYON SERTİFİKASI", bold: true, fontSize: 14, margin: [0, 10, 0, 0] },
        { text: "Calibration Certificate", fontSize: 10 },
      ],
      alignment: 'center',
    };
  }

  // Right column content
  getRightColumn(akraditasyonFirma, akraditationNo, certificateNo, certificateTarih, currentPage) {
    return {
      width: '25%',
      stack: [
        currentPage === 1 ?
          { image: akraditasyonFirma, fit: [75, 75], alignment: 'center' } :
          { text: '' },
        {
          table: {
            widths: [65],
            body: [
              [{ text: akraditationNo, alignment: 'center' }],
              [{ text: certificateNo, alignment: 'center' }],
              [{ text: certificateTarih, alignment: 'center' }],
            ],
          },
          marginTop: 2,
          marginLeft: 30,
        }
      ],
      alignment: 'right',
    };
  }

  // Footer content function
  getFooterContent(currentPage, pageCount, firstPageFooterDescription) {
    let firstPageFooterDescriptionToHtml = htmlToPdfmake(firstPageFooterDescription);
    firstPageFooterDescriptionToHtml = this.applyDefaultFontSize(firstPageFooterDescriptionToHtml);
    // İlk sayfa için footer içeriğini ayarlarken margin ve padding ekliyoruz.
    return {
      stack: [
        // Footer'da bir çizgi ekliyoruz
        {
          canvas: [{ type: 'line', x1: 30, y1: 0, x2: 550, y2: 0, lineWidth: 1 }],
        },
        currentPage === 1 ? {
          stack: [
            firstPageFooterDescriptionToHtml
          ],
          margin: [30, 0, 30, 0], // Alt margin'ini biraz daha azaltarak daha fazla alan bırakıyoruz
          fontSize: 8, // Font boyutunu küçültüyoruz
        } : { text: '' },
        // Sayfa numarasının olduğu kısım
        {
          text: `Sayfa No: ${currentPage} / ${pageCount}`,
          fontSize: 8,
          alignment: 'center',
          margin: [0, 5], // Sayfa numarasının alt kısmına margin ekliyoruz
        },

        // İngilizce sayfa numarası kısmı
        {
          text: `Page No: ${currentPage} / ${pageCount}`,
          fontSize: 6,
          alignment: 'center',
          margin: [0, 5], // Margin artırarak metnin alt kısmı daha fazla yer kaplasın
        },
      ],
      margin: [0, currentPage === 1 ? 0 : 50, 0, 0]
    };
  }

  async pdfDetail(isSave: boolean) {
    this._coreConfigService.setConfig({ emitEvent: true });
    this.getByIdLogo(this.calibration.accreditationOrganization)
    const logoKey = Object.keys(CalibrationlogoEnum);
    const key = logoKey[this.calibration.accreditationOrganization - 1];
    Object.keys(this.coreConfig.akraditasyonCompanies).find(k => k === key);
    const value = this.coreConfig.akraditasyonCompanies[key];
    console.log(value);
    if(this.calibration.akraditationCompanyFile){
      if (!this.calibration.akraditationCompanyFile.startsWith('data:image/png;base64,')) {
        this.calibration.akraditationCompanyFile = 'data:image/png;base64,' + this.calibration.akraditationCompanyFile;
      }
    }

    const issueDate: Date = new Date(this.certificateForm.value.issueDate);
    const year = issueDate.getFullYear().toString().slice(-2); // Yılın son iki basamağını al
    const month = (issueDate.getMonth() + 1).toString().padStart(2, '0'); // Ayı iki basamağa tamamla
    const formattedDate = month + '.' + year;

    const headerBilgi: headerBilgileri = {
      akraditationNo: value ?? '',
      akraditationFirma: this.calibration.accreditationOrganization ?? '',
      certificateNo: this.certificateNumber,
      certificateTarih: formattedDate,
      firmaAdi: this.calibration.akraditationCompany,
      firmaAdresi: this.calibration.akraditationCompanyAddres ?? '',
      firmaLogo: this.calibration.akraditationCompanyFile ?? '',
    }

    const calibrationDate = new Date(this.calibration.calibrationDate);
    const formattedCalibrationDate = `${calibrationDate.getDate().toString().padStart(2, '0')}.${(calibrationDate.getMonth() + 1).toString().padStart(2, '0')}.${calibrationDate.getFullYear()}`;

    const calibrationData: CalibrationData = {
      deviceOwner: this.calibration.companyName,
      address: this.calibration.companyAddress ?? '',
      orderNumber: this.calibration.transactionManagementNo,
      deviceName: this.calibration.deviceName,
      manufacturer: this.calibration.deviceBrand + '/' + this.calibration.deviceModel,
      modelType: this.calibration.deviceType,
      serialNumber: this.calibration.deviceSeriNo,
      calibrationDate: formattedCalibrationDate,
      certificateNo: this.certificateNumber,
      firstPageDescription: this.calibration.firstPageDescriptions[0].description,
      kalYapan: this.calibration.person,
      onaylayan: this.calibration.person,
      certificatePageNumber: this.pageCount + this.totalPages
    };

    const referenceString = (this.calibration.deviceReferenceMin && this.calibration.deviceReferenceMax && this.calibration.deviceReferenceUnitType)
      ? `${this.calibration.deviceReferenceMin}-${this.calibration.deviceReferenceMax} ${this.calibration.deviceReferenceUnitType}`
      : '-';
    const deliveryDate = new Date(this.calibration.deliveryDate);

    const formattedDeliveryDate = `${deliveryDate.getDate().toString().padStart(2, '0')}.${(deliveryDate.getMonth() + 1).toString().padStart(2, '0')}.${deliveryDate.getFullYear()}`;

    const references: Reference[] = this.calibration.calibrationReferencesDevices.map(device => ({
      deviceName: device.deviceName,
      brand: device.brandName,  // 'brandName' -> 'brand'
      model: device.modelName,  // 'modelName' -> 'model'
      serialNumber: device.seriNo,  // 'seriNo' -> 'serialNumber'
      certificateNumber: device.referenceDeviceMovement.calibrationNo,  // 'calibrationNo' -> 'certificateNumber'
      calibrationDate: this.formatDate(device.referenceDeviceMovement.calibrationDate),  // Format edilmiş tarih
      tracebility: device.referenceDeviceMovement.traceability  // 'traceability' -> 'tracebility'
    }));

    const calibrationDataPage2: CalibrationPage2 = {
      device: {
        deviceName: this.calibration.deviceName,
        serialNo: this.calibration.deviceSeriNo,
        deviceNumber: this.calibration.deviceCode ?? '-',
        location: this.calibration.devicePlace ?? '-',
        brand: this.calibration.deviceBrand,
        type: this.calibration.deviceModel,
        range: referenceString,
        resolution: this.calibration.deviceResolution ?? '-',
        incomingDateOfDeviceLaboratory: formattedDeliveryDate,
        visualFunctionInspectionDevice: this.certificateForm.value.visualAndFunctional ? 'Uygun' : 'Uygun Değil'
      },
      references: references,
      evironmentalConditions: this.calibration.enviromentalContents,
      calibrationMethod: this.calibration.calibrationMethodDescription,
      remarks: this.calibration.procedureDescription,
      compliance: this.calibration.conformityDeclartion,
      measurement: this.calibration.measurementUncertaintyDescription,
      measurementUncertainty: this.calibration.measurementUncertaintyDescription,
      description: this.calibration.calibrationMethodDescription
    };

    await this.generatePDF(headerBilgi, calibrationData, calibrationDataPage2, isSave);


  }

  formatDate(date: string): string {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, '0');
    const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Aylar 0'dan başladığı için +1 yapıyoruz
    const year = newDate.getFullYear();
    return `${day}.${month}.${year}`;  // Gün.Ay.Yıl formatı
  }

}

export interface headerBilgileri {
  firmaLogo: string;
  firmaAdi: string;
  firmaAdresi: string;
  akraditationFirma: number;
  akraditationNo: string;
  certificateNo: string;
  certificateTarih: string;
}

export interface CalibrationData {
  deviceOwner: string;
  address: string;
  orderNumber: string;
  deviceName: string;
  manufacturer: string;
  modelType: string;
  serialNumber: string;
  calibrationDate: string;
  certificatePageNumber?: number;
  onaylayan: string;
  kalYapan: string;
  certificateNo: string;
  firstPageDescription: string;
}

export interface CalibrationPage2 {
  measurementUncertainty: string; // Ölçüm Belirsizliği
  calibrationMethod: string; // Kalibrasyon Yöntemi
  references: Reference[]; // Referanslar
  device: Device;
  remarks: string; // Açıklamalar
  evironmentalConditions: any[];
  compliance: string;
  measurement: string;
  description: string;
}


export interface Device {
  deviceName: string;
  serialNo: string;
  deviceNumber: string;
  location: string;
  brand: string;
  type: string;
  range: string;
  resolution: string;
  incomingDateOfDeviceLaboratory: string;
  visualFunctionInspectionDevice: string;
}

export interface Reference {
  deviceName: string;
  brand: string;
  model: string;
  serialNumber: string;
  certificateNumber: string;
  calibrationDate: string;
  tracebility: string;
}